import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { AdminCatalogComponent } from './catalog/admin-catalog.component';
import { AdminLocationComponent } from './location/admin-location.component';
import { AdminSubCatalogComponent } from './subcatalog/admin-subcatalog.component';

@NgModule({
  declarations: [
    AdminCatalogComponent,
    AdminSubCatalogComponent,
    AdminLocationComponent
  ],
  imports: [
    CoreModule
  ],
  entryComponents: [
  ],
  exports: [
    AdminCatalogComponent,
    AdminSubCatalogComponent,
    AdminLocationComponent
  ]
})
export class AdminModule { }
